import { Routes } from '@angular/router';
import { QuestionnaireComponent } from './questionnaire.component';
import { QuestionnaireSplashComponent } from './splash/splash.component';
import { QuestionnaireFormComponent } from './form/form.component';
import { QuestionnairePreviewComponent } from './preview/preview.component';
var baseBreadcrumbs = [
    {
        label: 'projects.title',
        url: 'eyrus/projects'
    },
    {
        label: ':projectName',
        path: 'eyrus/contracts/:rootContractId/daily-status',
        inTitle: true
    },
    {
        label: 'projects.setting.title',
        path: 'eyrus/contracts/:rootContractId/settings',
        inTitle: true
    }
];
var ɵ0 = {
    viewType: 'general',
}, ɵ1 = {
    viewType: 'safety',
}, ɵ2 = {
    viewType: 'general',
    title: 'questionnaire.generalQuestionnaire',
    subview: true,
    stepsBack: 3,
    type: 'basic',
    questionnaireType: 'generalQuestionnaire',
    breadcrumbs: baseBreadcrumbs.concat([
        {
            label: 'projects.setting.dailyLogSetup',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log',
            inTitle: true
        },
        {
            label: 'questionnaire.generalQuestionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/general',
            inTitle: true
        },
    ])
}, ɵ3 = {
    viewType: 'safety',
    title: 'questionnaire.safetyQuestionnaire',
    subview: true,
    stepsBack: 3,
    type: 'basic',
    breadcrumbs: baseBreadcrumbs.concat([
        {
            label: 'projects.setting.dailyLogSetup',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log',
            inTitle: true
        },
        {
            label: 'questionnaire.safetyQuestionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/safety',
            inTitle: true
        }
    ])
}, ɵ4 = {
    viewType: 'walkthrough',
    contentType: 'walkthrough',
    title: 'questionnaire.walkthrough',
    subview: true,
    stepsBack: 3,
    type: 'basic',
    breadcrumbs: baseBreadcrumbs.concat([
        {
            label: 'projects.setting.dailyLogSetup',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log',
            inTitle: true
        },
        {
            label: 'questionnaire.walkthrough',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/walkthrough',
            inTitle: true
        }
    ])
}, ɵ5 = {
    viewType: 'safety',
    title: 'questionnaire.previewQuesstionnaire',
    subview: true,
    stepsBack: 1,
    type: 'basic',
    questionnaireType: 'safetyQuestionnaire',
    breadcrumbs: baseBreadcrumbs.concat([
        {
            label: 'projects.setting.dailyLogSetup',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log',
            inTitle: true
        },
        {
            label: 'questionnaire.safetyQuestionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/safety',
            inTitle: true
        },
        {
            label: 'questionnaire.previewQuesstionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/safety/preview',
            inTitle: true
        },
    ])
}, ɵ6 = {
    viewType: 'walkthrough',
    title: 'questionnaire.walkthrough',
    subview: true,
    stepsBack: 1,
    type: 'basic',
    questionnaireType: 'walkthrough',
    breadcrumbs: baseBreadcrumbs.concat([
        {
            label: 'projects.setting.dailyLogSetup',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log',
            inTitle: true
        },
        {
            label: 'questionnaire.walkthrough',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/walkthrough',
            inTitle: true
        },
        {
            label: 'questionnaire.previewQuesstionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/walkthrough/preview',
            inTitle: true
        },
    ])
}, ɵ7 = {
    viewType: 'general',
    title: 'questionnaire.previewQuesstionnaire',
    subview: true,
    stepsBack: 1,
    type: 'basic',
    questionnaireType: 'generalQuestionnaire',
    breadcrumbs: baseBreadcrumbs.concat([
        {
            label: 'projects.setting.dailyLogSetup',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log',
            inTitle: true
        },
        {
            label: 'questionnaire.generalQuestionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/general',
            inTitle: true
        },
        {
            label: 'questionnaire.previewQuesstionnaire',
            path: 'eyrus/contracts/:rootContractId/settings/daily-log/questionnaire/add/general/preview',
            inTitle: true
        },
    ])
};
var routes = [
    {
        path: '',
        component: QuestionnaireComponent,
        children: [
            {
                path: 'access',
                children: [
                    {
                        path: 'general',
                        component: QuestionnaireSplashComponent,
                        data: ɵ0
                    },
                    {
                        path: 'safety',
                        component: QuestionnaireSplashComponent,
                        data: ɵ1
                    }
                ]
            },
            {
                path: 'add',
                children: [
                    {
                        path: 'general',
                        component: QuestionnaireFormComponent,
                        data: ɵ2
                    },
                    {
                        path: 'safety',
                        component: QuestionnaireFormComponent,
                        data: ɵ3
                    },
                    {
                        path: 'walkthrough',
                        component: QuestionnaireFormComponent,
                        data: ɵ4
                    },
                    {
                        path: 'safety/preview',
                        component: QuestionnairePreviewComponent,
                        data: ɵ5
                    },
                    {
                        path: 'walkthrough/preview',
                        component: QuestionnairePreviewComponent,
                        data: ɵ6
                    },
                    {
                        path: 'general/preview',
                        component: QuestionnairePreviewComponent,
                        data: ɵ7
                    }
                ]
            }
        ]
    }
];
var QuestionnaireRoutingModule = /** @class */ (function () {
    function QuestionnaireRoutingModule() {
    }
    return QuestionnaireRoutingModule;
}());
export { QuestionnaireRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
